import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    selectedRmId: "",
    selectedRm: null,
    selectedAreaId: "",
    selectedArea: null,
    selectedCompany: null,
    selectedCompanyId: "",
    selectedGame: null,
    selectedFollower: null,
    selectedStudent: null,
    selectedArticle: null
};

export const selectedSlice = createSlice({
    name: 'selected',
    initialState,
    reducers: {
        storeSelectedRmId: (state, action) => {
            state.selectedRmId = action.payload.rmId
        },
        storeSelectedRm: (state, action) => {
            state.selectedRm = action.payload.rm;
            state.selectedRmId = action.payload.rm?.id;
            state.selectedAreaId = action.payload.rm?.areaId;
            state.selectedCompanyId = action.payload.rm?.companyId;
        },
        resetSelectedRm: state => {
            state.selectedRm = initialState.selectedRm;
            state.selectedRmId = initialState.selectedRmId;
        },

        storeSelectedAreaId: (state, action) => {
            state.selectedAreaId = action.payload.areaId
        },
        storeSelectedArea: (state, action) => {
            state.selectedArea = action.payload.area;
            state.selectedAreaId = action.payload.area.id;
        },
        resetSelectedArea: state => {
            state.selectedArea = initialState.selectedArea;
            state.selectedAreaId = initialState.selectedAreaId;
        },

        storeSelectedCompanyId: (state, action) => {
            state.selectedCompanyId = action.payload.companyId
        },
        storeSelectedCompany: (state, action) => {
            state.selectedCompany = action.payload.company;
            state.selectedCompanyId = action.payload.company.id;
        },
        resetSelectedCompany: state => {
            state.selectedCompany = initialState.selectedCompany;
            state.selectedCompanyId = initialState.selectedCompanyId;
        },

        storeSelectedGame: (state, action) => {
            state.selectedGame = action.payload.game
        },
        resetSelectedGame: state => {
            state.selectedGame = initialState.selectedGame
        },

        storeSelectedFollower: (state, action) => {
            state.selectedFollower = action.payload.follower
        },
        resetSelectedFollower: state => {
            state.selectedFollower = initialState.selectedFollower
        },

        storeSelectedStudent: (state, action) => {
            state.selectedStudent = action.payload.student
        },
        resetSelectedStudent: state => {
            state.selectedStudent = initialState.selectedStudent
        },

        storeSelectedArticle: (state, action) => {
            state.selectedArticle = action.payload.article
        },
        resetSelectedArticle: state => {
            state.selectedArticle = initialState.selectedArticle
        },

        resetSelected: state => initialState
    }
});

export const {
    storeSelectedRmId,
    storeSelectedRm,
    resetSelectedRm,
    storeSelectedAreaId,
    storeSelectedArea,
    resetSelectedArea,
    storeSelectedCompanyId,
    storeSelectedCompany,
    resetSelectedCompany,
    storeSelectedGame,
    resetSelectedGame,
    storeSelectedFollower,
    resetSelectedFollower,
    storeSelectedStudent,
    resetSelectedStudent,
    storeSelectedArticle,
    resetSelectedArticle,
    resetSelected
} = selectedSlice.actions;

export const selectSelectedRm = state => state.selected.selectedRm;
export const selectSelectedRmId = state => state.selected.selectedRmId;
export const selectSelectedArea = state => state.selected.selectedArea;
export const selectSelectedAreaId = state => state.selected.selectedAreaId;
export const selectSelectedCompany = state => state.selected.selectedCompany;
export const selectSelectedCompanyId = state => state.selected.selectedCompanyId;
export const selectSelectedGame = state => state.selected.selectedGame;
export const selectSelectedFollower = state => state.selected.selectedFollower;
export const selectSelectedStudent = state => state.selected.selectedStudent;
export const selectSelectedArticle = state => state.selected.selectedArticle;

export default selectedSlice.reducer;
